///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ActivityDTO } from '../../../services/project-socket/activity-dto.model';
import { GtthHistoryService } from './history-service';
import { SOCKET_LOGS_ENABLED } from '../../../../environments/environment';
import { ProjectDTO } from '../../../generated/shared-types.model';

export abstract class GtthAbstractCommand {
    protected historyService: GtthHistoryService;
    protected project: ProjectDTO;
    protected commandResolve: any;
    protected commandReject: any;

    protected commandId: number;

    protected isDoCommand: boolean;
    protected isDoLocally: boolean;

    setHistoryService(historyService: GtthHistoryService): any {
        this.historyService = historyService;
        return this;
    }

    setProject(project: ProjectDTO): any {
        this.project = project;
        return this;
    }

    setCommandId(commandId: number): any {
        this.commandId = commandId;
        return this;
    }

    getCommandId(): number {
        return this.commandId;
    }

    abstract getCommandName(): string;

    do(doLocally: boolean): Promise<boolean> {
        this.isDoCommand = true;
        this.isDoLocally = doLocally;

        const promise = new Promise<boolean>((resolve, reject) => {
            this.commandResolve = resolve;
            this.commandReject = reject;
        });
        this.doCommand();
        return promise;
    }

    undo(doLocally: boolean): Promise<boolean> {
        this.isDoCommand = false;
        this.isDoLocally = doLocally;

        const promise = new Promise<boolean>((resolve, reject) => {
            this.commandResolve = resolve;
            this.commandReject = reject;
        });
        this.undoCommand();
        return promise;
    }

    applyActivity(activityDto: ActivityDTO): void {
        if (!activityDto.doLocally && SOCKET_LOGS_ENABLED) {
            console.log('Recive activity', activityDto);
        }

        if (activityDto.doCommand) {
            this.doCommandActivity(activityDto);
        } else {
            this.undoCommandActivity(activityDto);
        }
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        // this function is optional since not all commands may send data to backend
    }

    undoCommandActivity(activityDto: ActivityDTO): void {
        // this function is optional since not all commands may be reverted
    }

    isDisabledInReadOnlyMode(): boolean {
        return false;
    }

    isModifyTopology(): boolean {
        return false;
    }

    isClearDesign(): boolean {
        return false;
    }

    protected createActivityDTO(isUiBroadcast: boolean): ActivityDTO {
        const activityDto = new ActivityDTO(
            this.getCommandId(),
            this.getCommandName(),
            this.historyService.principal.getLoginOrUndefined(),
            isUiBroadcast,
            this.isDoCommand,
            this.isDoLocally
        );
        activityDto.successful = true;
        if (!this.isDoLocally && !isUiBroadcast) {
            activityDto.userSession = this.historyService.projectUserSessionService.getSessionObjectIfChanged();
            if (activityDto.userSession && this.historyService.map) {
                const center = this.historyService.map.getCenter();
                activityDto.userSession.bbox = [center.lng(), center.lat(), this.historyService.map.getZoom()];
            }
        }
        activityDto.topologyChanged = this.historyService.topologyChanged;
        return activityDto;
    }

    protected abstract doCommand(): void;

    protected undoCommand(): void {
        this.commandResolve(false);
    }

    protected sendActivity(activityDto: ActivityDTO): void {
        if (activityDto.doLocally) {
            this.applyActivity(activityDto);
        } else {
            this.historyService.sendCommandActivity(activityDto);
        }
    }
}
